const env = import.meta.env || {};

const toBool = value => value === true || value === 'true' || value === '1';

const isDevelopment = env.MODE ? env.MODE === 'development' : Boolean(env.DEV);
const useRemoteApi = toBool(env.VITE_USE_REMOTE_API);

const DEFAULTS = {
  apiHost: 'localhost:8000',
  apiProtocol: 'http',
  socketHost: 'localhost:8000',
  socketProtocol: 'ws',
  apiBasePath: '/api/v1',
};

const normalizePath = path => {
  if (!path) return '';
  return path.startsWith('/') ? path : `/${path}`;
};

const resolveValue = (remoteValue, fallback) =>
  useRemoteApi && remoteValue ? remoteValue : fallback;

const apiHost = resolveValue(env.VITE_API_HOST, DEFAULTS.apiHost);
const apiProtocol = resolveValue(env.VITE_API_PROTOCOL, DEFAULTS.apiProtocol);
const socketHost = resolveValue(
  env.VITE_SOCKET_HOST || env.VITE_API_HOST,
  DEFAULTS.socketHost,
);
const socketProtocol = resolveValue(
  env.VITE_SOCKET_PROTOCOL,
  DEFAULTS.socketProtocol,
);
const apiBasePath = normalizePath(
  env.VITE_API_BASE_PATH || DEFAULTS.apiBasePath,
);

export const API_CONFIG = Object.freeze({
  isDevelopment,
  useRemoteApi,
  host: apiHost,
  protocol: apiProtocol,
  socketHost,
  socketProtocol,
  basePath: apiBasePath,
});

export const apiBaseUrl = useRemoteApi
  ? `${apiProtocol}://${apiHost}${apiBasePath}`
  : apiBasePath;
export const socketBaseUrl = `${socketProtocol}://${socketHost}`;

export const API_BASE_URL = apiBaseUrl;
export const SOCKET_BASE_URL = socketBaseUrl;

export const buildApiUrl = path => `${apiBaseUrl}${normalizePath(path)}`;
export const buildSocketUrl = path => `${socketBaseUrl}${normalizePath(path)}`;

export default {
  ...API_CONFIG,
  API_BASE_URL,
  SOCKET_BASE_URL,
  apiBaseUrl: API_BASE_URL,
  socketBaseUrl: SOCKET_BASE_URL,
  buildApiUrl,
  buildSocketUrl,
};
